import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { useNavigation } from "../../utils/navigation";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderInput from "./components/HeaderInput";
import CategoryList from "./components/CategoryList";
import HeaderSlider from "./components/HeaderSlider";
import HamburgerMenuLeft from "./mobile/HamburgerMenuLeft";
import CartMenu from "./mobile/CartMenu";
import { AuthUserContext } from "../../context/AuthUserContext";
import { useTranslation } from "react-i18next";
import Language from "../../components/account/Language";

const Container = styled.div`
  position: relative;
`;

const MainHeaderWrapper = styled.div`
  width: 100%;

  max-width: 100vw;
  box-shadow: var(--shadow-default);
  z-index: var(--zindex-top);
  position: fixed;
  top: ${(props) => (props.$isScrolled ? "0" : "initial")};
  left: 0;
  //
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--bg-200);

  box-shadow: ${(props) =>
    props.$isScrolled ? "var(--shadow-medium)" : "none"};

  transition: ${(props) =>
    props.$isScrolled ? "all 0.2s ease-out" : "all 0.1s ease-in"};

  @media (min-width: 768px) {
    //min-height: var(--navbar-height-desktop);
  }
  @media (min-width: 768px) and (max-width: 1040px) {
  }
`;
const GridContainer = styled.header`
  height: var(--navbar-height);
  width: 100%;
  max-width: 90%;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (min-width: 768px) {
    height: var(--navbar-height-desktop);
    grid-template-columns: 1fr 1fr 2fr;
    max-width: var(--max-width-container);
    padding: 0;
  }
  @media (min-width: 768px) and (max-width: 1040px) {
    max-width: 90%;
  }
`;
const GridItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-lg);

  &:nth-child(2) {
    justify-content: center;
  }

  &:nth-child(3) {
    justify-content: flex-end;
  }
  @media (min-width: 768px) {
    &:nth-child(1) {
      order: 2; /* Prvi element postaje drugi */
    }

    &:nth-child(2) {
      order: 1; /* Drugi element postaje prvi */
    }

    &:nth-child(3) {
      order: 3; /* Treći element ostaje isti */
    }
  }
  @media (min-width: 768px) and (max-width: 1040px) {
    &:nth-child(1) {
      order: 1; /* Prvi element postaje drugi */
      flex-direction: row-reverse;
    }

    &:nth-child(2) {
      order: 2; /* Drugi element postaje prvi */
    }

    &:nth-child(3) {
      order: 3; /* Treći element ostaje isti */
    }
  }
`;
const GridItemRight = styled(GridItem)`
  justify-content: flex-end;
`;

const LogoImg = styled.div`
  color: var(--primary-200);
  font-size: var(--font-size-large);
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.438px;
  display: flex;
  gap: var(--spacing-xs);

  align-items: center;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: var(--font-size-xlarge);
  }
`;
const LogoText = styled.span`
  display: none;
  @media (min-width: 480px) {
    display: inline;
  }
`;
const CartContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  @media (min-width: 768px) {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
  }
  svg {
    fill: var(--text-200);
    color: var(--text-200);
    transition: fill 0.3s ease, color 0.3s ease; /* Dodaj tranziciju za glatki prelaz boje */
  }

  &:hover {
    background-color: var(--bg-300);
  }
  &:hover svg {
    fill: var(--primary-100); /* Boja pri hoveru */
    color: var(--primary-100);
  }
`;
const FavoriteContainer = styled(CartContainer)`
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
  }
`;
const CartSVG = styled.svg`
  width: 16px;
  height: 16px;
  cursor: pointer;
  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;
const IconDivDesktop = styled.div`
  display: none;

  @media (min-width: 1040px) {
    display: block;
  }
`;
const IconDivNoDesktop = styled.div`
  display: block;
  @media (min-width: 1040px) {
    display: none;
  }
`;

const SumQuantity = styled.div`
  cursor: pointer;
  position: absolute;
  right: -10px;
  top: -4px;

  background-color: var(--error-color);
  color: var(--bg-100);
  border-radius: var(--border-radius-large);
  padding: 4px 2px;
  margin: 0;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-small);
  font-weight: 200;
`;
const LinksFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: var(--spacing-md);
`;
const Link = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-transform: uppercase;
  font-size: var(--font-size-small);
  font-weight: 600;
  letter-spacing: 0.4px;
  color: var(--text-100);
  padding: 8px 2px;
  cursor: pointer;
  transition: color var(--transition-fast);

  &::after {
    content: "";
    position: absolute;
    left: 2px;
    right: 2px;
    bottom: 4px;
    height: 2px;
    border-radius: 2px;
    background-color: var(--primary-200);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform var(--transition-fast);
  }

  &:hover {
    color: var(--primary-200);
  }
  &:hover::after {
    transform: scaleX(1);
  }
`;
const FavoriteQuantity = styled.div`
  position: absolute;
  bottom: 6px;
  color: var(--bg-100);
  font-size: var(--font-size-base);
  @media (min-width: 768px) {
    bottom: 8px;
  }
`;

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoHovered, setLogoHovered] = useState(false);
  const { authTokens } = useContext(AuthUserContext);
  const { goToHome, goToLogin, goToShop, goToAccount, goToBestSeller } =
    useNavigation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0); // Ažurira state ako korisnik skroluje nadole
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Očistite event listener kad se komponenta demontira
    };
  }, []);

  //CART
  const cartItems = useSelector((state) => state.cart.itemsList);
  let totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const favorite = 2;
  return (
    <Container>
      <MainHeaderWrapper $isScrolled={isScrolled}>
        <HeaderSlider />
        <GridContainer>
          <GridItem>
            <HeaderInput />
            <IconDivNoDesktop>
              <HamburgerMenuLeft />
            </IconDivNoDesktop>
          </GridItem>
          <GridItem>
            <LogoImg
              onClick={() => navigate(goToHome())}
              role="button"
              tabIndex={0}
              aria-label={t("ARIA.HOME")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(goToHome());
                }
              }}
            >
              <svg
                width="50"
                height="50"
                viewBox="0 0 298 298"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onMouseEnter={() => setLogoHovered(true)}
                onMouseLeave={() => setLogoHovered(false)}
              >
                <path
                  d="M148.707 0C66.7245 0 0 66.7245 0 148.707C0 230.689 66.7245 297.414 148.707 297.414C230.689 297.414 297.414 230.689 297.414 148.707C297.414 66.7245 230.689 0 148.707 0ZM294.707 148.707C294.707 188.275 278.843 224.204 253.18 250.567L244.688 242.074C268.158 217.904 282.669 184.962 282.669 148.707C282.669 112.452 267.878 78.8562 243.988 54.6394L252.48 46.1472C278.563 72.557 294.661 108.766 294.661 148.707H294.707ZM17.3576 148.707C17.3576 76.2899 76.2432 17.4043 148.66 17.4043C221.077 17.4043 279.963 76.2899 279.963 148.707C279.963 221.124 221.077 280.009 148.66 280.009C76.2432 280.009 17.3576 221.124 17.3576 148.707ZM250.52 44.2808L242.028 52.7731C217.858 29.2562 184.915 14.7447 148.614 14.7447C112.312 14.7447 79.416 29.2562 55.2458 52.7731L46.7536 44.2808C73.0701 18.6176 108.999 2.75295 148.567 2.75295C188.135 2.75295 224.11 18.6175 250.427 44.3275L250.52 44.2808ZM44.7939 46.1939L53.2862 54.6862C29.3494 78.9029 14.558 112.172 14.558 148.8C14.558 185.429 29.0693 218.044 52.5862 242.214L44.1406 250.707C18.4307 224.39 2.56627 188.415 2.56627 148.847C2.56627 109.279 18.7107 72.6504 44.7939 46.2872V46.1939ZM46.0539 252.667L54.5461 244.174C78.7629 268.064 111.985 282.856 148.614 282.856C185.242 282.856 218.511 268.064 242.728 244.128L251.22 252.62C224.857 278.703 188.602 294.848 148.66 294.848C108.719 294.848 72.5102 278.703 46.147 252.667"
                  fill="var(--text-200)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M207.722 57.7351C202.622 66.9627 200.922 78.8759 205.416 87.3302C214.54 104.491 230.158 114.314 239.894 131.851C273.15 191.781 209.011 201.72 174.784 209.915C155.428 214.537 143.812 230.506 158.492 258.688C214.436 253.98 258.39 207.07 258.39 149.903C258.39 111.144 238.177 77.1018 207.722 57.7266"
                  fill={
                    !logoHovered ? "var(--primary-200)" : "var(--primary-100)"
                  }
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M191.927 105.506C177.373 95.2564 162.525 82.7355 160.972 63.8935C160.307 55.8558 164.875 48.4915 171.632 43.0459C157.459 40.0907 142.84 39.9776 128.623 42.713C114.406 45.4483 100.873 50.9779 88.8086 58.9812C96.9207 91.2874 127.561 94.6763 155.629 103.143C195.722 115.235 214.322 153.656 158.871 159.818C81.4401 168.423 72.2954 187.545 127.861 256.987C133.447 258.095 139.112 258.763 144.803 258.984C114.222 212.039 131.18 198.9 188.95 180.965C245.166 163.485 224.646 128.565 191.925 105.51"
                  fill="var(--accent-100)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M123.936 118.509C100.162 114.213 67.312 112.348 58.2119 97.5595C57.3549 96.166 56.5939 94.7157 55.9342 93.2188C45.5264 110.296 40.0342 129.915 40.0626 149.915C40.0626 197.952 71.1131 238.761 114.236 253.341C95.0693 233.567 63.4812 210.21 71.1047 172.043C76.204 146.547 105.038 150.269 127.675 148.404C160.298 145.722 156.82 124.463 123.927 118.509"
                  fill={
                    !logoHovered ? "var(--primary-200)" : "var(--primary-100)"
                  }
                />
              </svg>
              <LogoText>SnusCo</LogoText>
            </LogoImg>
          </GridItem>

          <GridItemRight>
            <IconDivDesktop>
              <Link onClick={() => navigate(goToShop())}>
                {t("HEADER.NICOTINE_POUCHES")}
              </Link>
            </IconDivDesktop>
            <IconDivDesktop>
              <CategoryList />
            </IconDivDesktop>
            <IconDivDesktop>
              <Link onClick={() => navigate(goToBestSeller())}>
                {t("HEADER.TOP_SELLER")}
              </Link>
            </IconDivDesktop>

            {/* <FavoriteContainer>
              <svg
                width="44px"
                height="44px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z"
                  fill={favorite > 0 ? "var(--error-color)" : "var(--text-200)"}
                />
              </svg>
              {favorite > 0 && <FavoriteQuantity>{favorite}</FavoriteQuantity>}
            </FavoriteContainer> */}

            <CartMenu />
            <CartContainer
              onClick={() => {
                if (authTokens) {
                  navigate(goToAccount());
                } else {
                  navigate(goToLogin());
                }
              }}
            >
              <svg
                width="21px"
                height="21px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM4 20.5c0-3.6 3.6-6.5 8-6.5s8 2.9 8 6.5"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </CartContainer>
            <IconDivDesktop>
              <Language />
            </IconDivDesktop>
          </GridItemRight>
        </GridContainer>
      </MainHeaderWrapper>
      <div />
    </Container>
  );
};

export default Header;
